import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createTextVNode(" Đang tải, vui lòng chờ lại "),
    _createElementVNode("br", null, null, -1),
    _createElementVNode("br", null, null, -1),
    _createElementVNode("img", {
      src: "https://embed.plcdn.xyz/images/loading.gif",
      border: "0"
    }, null, -1),
    _createElementVNode("br", null, null, -1),
    _createElementVNode("br", null, null, -1),
    _createTextVNode(" Sau khi hiển thị, trang web được làm mới tự động, bạn không cần làm mới trang tận tay. "),
    _createElementVNode("br", null, null, -1)
  ])))
}